export const nodeTypes = {
  TITLE: "TitleSection",
  TEXT: "TextSection",
  LIST: "List",
  CAROUSEL: "Carrousel",
  GRID: "Grid",
  CATALOG: "Catalog",
  MASTER_BANNER: "MasterBanner",
  CALENDAR: "Calendar",
  IN_PROGRESS: "EnrollmentsInProgress",
  UPGRADE: "Upgrade",
  CAMPAIGN: "Campaign",
  MEETINGS: "Meeting",
  KNOWLEDGE_PRE_TEST: "PreTest"
};

export const contentTypes = {
  ARTICLE: "article",
  VIDEO: "video",
  AUDIO: "audio",
  HTML_PACKAGE: "html-package",
  NEW_PAGE: "new-page",
  NEW_BANNER_IMAGE: "new-banner-image",
  SCORM: "scorm",
  FILE: "file",
  KNOWLEDGE_ASSESMENT: "knowledge-assessment",
  REACTION_ASSESMENT: "reaction-assessment",
};

export const elementTypes = {
  NODE: "NODE",
  BANNER_IMAGE: "IMAGE",
  CONTENT: "CONTENT",
  REDIRECT: "REDIRECT",
};

export const evaluationTypes = {
  REACTION: { indice: "1", url: "reaction-evaluation" },
  KNOWLEDGE: { indice: "2", url: "knowledge-evaluation" },
};
